import React from 'react';
import { GatsbyImage, IGatsbyImageData, GatsbyImageProps } from 'gatsby-plugin-image';
import { StyledImage } from './image.styled';

export interface ImageProps {
  alt?: string;
  url?: string;
  gatsbyImageData?: IGatsbyImageData;
  className?: string;
  objectFit?: GatsbyImageProps['objectFit'];
  loading?: 'lazy' | 'eager';
}

const Image = ({
  gatsbyImageData,
  url = '',
  alt = '',
  className = '',
  objectFit,
  loading = 'lazy',
}: ImageProps): JSX.Element => (
  <>
    {gatsbyImageData ? (
      <GatsbyImage
        image={gatsbyImageData}
        alt={alt || ''}
        className={className}
        objectFit={objectFit}
        loading={loading}
      />
    ) : (
      <StyledImage src={url} alt={alt || ''} className={className} loading={loading} />
    )}
  </>
);

export default Image;
